/** 已激活详情弹窗顶部「今日收益 / 日化」占位（接口未接时） */
export const ACTIVE_AGENT_EARNINGS_SUMMARY_MOCK = {
  todayEarnedU: "0",
  dailyRate: "-%",
};

export const AIF_INCOME_HISTORY = [
  { date: "2025-04-07", aifAmount: 256.41, usdValue: 6, aifPrice: 0.0234 },
  { date: "2025-04-06", aifAmount: 427.35, usdValue: 10, aifPrice: 0.0234 },
  { date: "2025-04-05", aifAmount: 256.41, usdValue: 6, aifPrice: 0.0234 },
  { date: "2025-04-04", aifAmount: 256.41, usdValue: 6, aifPrice: 0.0234 },
  { date: "2025-04-03", aifAmount: 256.41, usdValue: 6, aifPrice: 0.0234 },
];
